import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

class EmployerReferenceRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isIncomeChangeDateRequired: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = [];
        inputComponents = inputComponents.concat(this.inputComponents);
        this.childComponents.filter(component => {
            return (component !== null) && (component !== undefined);
        }).map(component => {
            inputComponents = inputComponents.concat(component.getChildInputComponents());
        });

        return inputComponents;
    }

    /**
     * Toggle the state for requiring an end date. Used for contract employments.
     *
     * @param value
     */
    toggleContractDurationValidation(value) {
        this.setState({ isContractDurationRequired: value == '2' ? true : false });
    }

    /**
     * Toggle the state for requiring an date if the income of the applicant is
     * not considered as 'stable'.
     *
     * @param value
     */
    toggleIncomeChangedDateValidation(value) {
        this.setState({ isIncomeChangeDateRequired: value === false ? true : false });
    }

    render() {
        return (
            <div>
                <Field
                    fieldName={'employmentStartDate'}
                    type={'date'}
                    subType={'full'}
                    question={'Please confirm their employment contract start date'}
                    storageKey={'employmentStartDate'}
                    source={this.props.source}
                    dataValidation={'required_field'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'jobTitle'}
                    type={'text'}
                    question={'Please confirm their job title'}
                    maxLength={70}
                    storageKey={'jobTitle'}
                    source={this.props.source}
                    dataValidation={'required_field.non_mandatory'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'jobType'}
                    type={'button-choice'}
                    question={'Is this position full time or part time?'}
                    storageKey={'jobType'}
                    source={this.props.source}
                    options={[
                        {
                            value: 1,
                            text: 'Full time'
                        },
                        {
                            value: 2,
                            text: 'Part time'
                        }
                    ]}
                    dataValidation={'required_field.non_mandatory'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'employmentType'}
                    type={'button-choice'}
                    question={'Is this position permanent or contract?'}
                    storageKey={'employmentType'}
                    source={this.props.source}
                    options={[
                        {
                            value: 1,
                            text: 'Permanent'
                        },
                        {
                            value: 2,
                            text: 'Contract'
                        }
                    ]}
                    dataValidation={'required_field.non_mandatory'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    callbackFunction={this.toggleContractDurationValidation.bind(this)}
                />

                {this.state.isContractDurationRequired === true ?
                    <Field
                        fieldName={'contractDurationInMonths'}
                        type={'number'}
                        question={'Contract duration in months'}
                        storageKey={'contractDuration'}
                        source={this.props.source}
                        dataValidation={'number_only'}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                        inputExtra={'Please enter only whole numbers.'}
                    />
                : null}

                <Field
                    type={'money'}
                    fieldName={'annualIncome'}
                    question={'Please confirm their gross basic annual income'}
                    storageKey={'annualIncome'}
                    source={this.props.source}
                    dataValidation={'2_decimal_money'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    type={'money'}
                    fieldName={'commission'}
                    question={'Any regular bonuses/overtime/commission?'}
                    storageKey={'commission'}
                    dataValidation={'2_decimal_money.non_mandatory'}
                    source={this.props.source}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName={'isIncomeStable'}
                    type={'button-choice'}
                    question={'Would you expect the applicant\'s income to remain at or above this level for the next six months?'}
                    storageKey={'isIncomeStable'}
                    source={this.props.source}
                    options={[
                        {
                            value: true,
                            text: 'Yes'
                        },
                        {
                            value: false,
                            text: 'No'
                        }
                    ]}
                    dataValidation={'required_field'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                    callbackFunction={this.toggleIncomeChangedDateValidation.bind(this)}
                />

                {this.state.isIncomeChangeDateRequired === true ?
                    <Field
                        fieldName={'incomeChangeDate'}
                        type={'date'}
                        subType={'full'}
                        question={'As you have indicated above that the applicant\'s income is likely to change, please give the date that this change will be effective from.'}
                        storageKey={'employmentEndDate'}
                        source={this.props.source}
                        dataValidation={'six_month_income_change'}
                        ref={(instance) => {this.inputComponents.push(instance);}}
                    />
                : null}

                <Field
                    fieldName={'refereeName'}
                    type={'text'}
                    question={'Your name'}
                    storageKey={'refereeName'}
                    source={this.props.source}
                    maxLength={60}
                    dataValidation={'alpha_and_space_only'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />
            </div>
        );
    }
}

EmployerReferenceRequest.propTypes = {
    source: PropTypes.string.isRequired,
};

export default EmployerReferenceRequest;


// WEBPACK FOOTER //
// ./src/components/Screens/ReferenceRequest/Employer.js